import React, { useEffect } from 'react';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
  Paper,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../dashboard/theme/customizations';
import AppTheme from '../../../shared-theme/AppTheme';
import { Add, Warehouse, Inventory, TrendingUp, Assessment } from '@mui/icons-material';
import AgregarAlmacen from './agregaralmacen';
import AlmacenDetails from './almacenDetails';
import { StyledCellHeader } from '../../../components/StyledCellHeader';
import { fetchAlmacenes } from '../../../utils/generalsFetch';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../../../components/EmptyState';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};


const AlmacenesPage = (props) => {
    const navigate = useNavigate()

    const [openAgregarAlmacen, setOpenAgregarAlmacen] = React.useState(false);
    const [warehouses, setWarehouses] = React.useState([])
    const [showAlmacenDetails, setShowAlmacenDetails] = React.useState(false);
    const [error, setError] = React.useState()

    useEffect(() => {
      fetchAlmacenes({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
      .then((data) => {
        setWarehouses(data);
      })
      .catch(err => setError(err.message));
  
      }, []);
  
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header parent={"Logistica y Almacenes"} child={"Almacenes"}/>
            <Container maxWidth={false} sx={{ px: 5, py: 5 }}>
                <AgregarAlmacen open={openAgregarAlmacen} onClose={() => {setOpenAgregarAlmacen(false)}}/>
                {!showAlmacenDetails?
                <Box maxWidth={960} mx="auto">
                    <Stack direction="row" justifyContent="space-between" alignItems="center" px={2} py={2}>
                        <Typography variant="h4" fontWeight={700}>Gestión de Almacenes</Typography>
                        <Button onClick={()=>{setOpenAgregarAlmacen(true)}} startIcon={<Add/>} variant="contained" color='primarybutton' sx={{  fontWeight:"bold" }}>Agregar nuevo almacén</Button>
                    </Stack>

                    {/* Show empty state if no warehouses */}
                    {warehouses.length === 0 ? (
                        <EmptyState 
                            icon={Warehouse}
                            title="No hay almacenes registrados"
                            description="Comienza creando tu primer almacén para gestionar tu inventario de manera eficiente y organizada."
                            features={[
                                {
                                    icon: Inventory,
                                    title: "Control de Inventario",
                                    description: "Gestión completa de productos y stock"
                                },
                                {
                                    icon: TrendingUp,
                                    title: "Seguimiento en Tiempo Real",
                                    description: "Monitoreo de movimientos y niveles"
                                },
                                {
                                    icon: Assessment,
                                    title: "Reportes Detallados",
                                    description: "Análisis de rendimiento del almacén"
                                }
                            ]}
                            buttonText="Crear Primer Almacén"
                            onButtonClick={() => setOpenAgregarAlmacen(true)}
                            helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
                        />
                    ) : (
                        <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 'none', mt: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                      <StyledCellHeader sx={{fontWeight:"bold"}}>Nombre del almacén</StyledCellHeader>
                                      <StyledCellHeader sx={{fontWeight:"bold"}}>Direccion del almacén</StyledCellHeader>
                                      <StyledCellHeader sx={{fontWeight:"bold"}}>Cantidad de productos</StyledCellHeader>
                                      <StyledCellHeader sx={{fontWeight:"bold"}}>Acciones</StyledCellHeader>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {warehouses.map((w) => (
                                    <TableRow key={w.label}>
                                        <TableCell>{w.label}</TableCell>
                                        <TableCell sx={{ color: '#6a7681' }}>{w.direccion}</TableCell>
                                        <TableCell sx={{ color: '#6a7681' }}>{""}</TableCell>
                                        <TableCell sx={{ color: '#6a7681', fontWeight: 'bold' }} onClick={()=>{navigate(`/logistica/almacenes/${w.value}`)}}>
                                         | Ver detalles
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
                :
                <AlmacenDetails onClose={() => {setShowAlmacenDetails(false)}}/>
                
                }
            </Container>
          </Stack>
        </Box>
      </Box>
    </AppTheme>

  );
};

export default AlmacenesPage;
